import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';
import clsx from 'clsx';

interface ThemeToggleProps {
  disabled?: boolean;
}

export function ThemeToggle({ disabled }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      disabled={disabled}
      className={clsx(
        "p-2 rounded-lg bg-[--bg-tertiary] hover:bg-[--state-hover] transition-colors",
        disabled && "opacity-50 cursor-not-allowed"
      )}
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <Sun className="w-5 h-5 text-[--text-secondary]" />
      ) : (
        <Moon className="w-5 h-5 text-[--text-secondary]" />
      )}
    </button>
  );
}